<template>
  <div id="skinNotificator"></div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

/* todo write here all the listener message for toolbar notification */
export default {
  name: 'SkinToolbarNotificator',
  components: {},
  data: () => ({
    isHomepageActive: true
  }),
  mounted() {
    console.log('[MOUNTED SKINTOOLBARNOTIFICATOR]');
    window.addEventListener('message', this.handleMessage);
    this.sendModeMessageToSkinV2();
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage);
  },
  computed: {
    ...mapGetters({
      getPreview: 'odds/getPreview',
      getEventsDetail: 'odds/getEventsDetail',
      getLiveMode: 'odds/getLiveMode',
      getProgramOpen: 'settings/getProgramOpen'
    })
  },
  methods: {
    ...mapActions({}),

    isHomePage() {
      if (this.getPreview.length > 0 || this.getEventsDetail.length > 0) {
        this.isHomepageActive = false;
      } else {
        this.isHomepageActive = true;
      }
    },

    handleMessage(event) {
      if (event != null && event.data != null && event.data.type != null) {
        switch (event.data.type) {
          case 'openHomeSportPage':
            console.log('openHomeSportPage');
            this.$root.$emit('set_live_mode_preview_and_reset_state', true);
            break;
          case 'openSportPage':
            console.log('openSportPage');
            this.$root.$emit('set_live_mode_preview', true);
            break;
          case 'openLiveSportPage':
            console.log('openLiveSportPage');
            this.$root.$emit('set_live_mode_detail', true);
            break;
          case 'toggleSportCart':
            console.log('toggleSportCart');
            this.$root.$emit('cart_handling', true);
            this.sendModeMessageToSkinV2();
            break;
          case 'openSportTree':
            console.log('openSportTree');
            this.$root.$emit('open_sidebar_left', true);
            break;
        }
      }
    },
    sendModeMessageToSkin() {
      const vm = this;
      window.parent.postMessage(
        {
          type: 'sportMode',
          mode: vm.getLiveMode
        },
        '*'
      );
    },
    sendModeMessageToSkinV2() {
      const vm = this;
      window.parent.postMessage(
        {
          type: 'sportModeWithTreeInfo',
          mode: vm.getLiveMode,
          treeStatus: vm.getProgramOpen
        },
        '*'
      );
    }
  },
  watch: {
    getPreview(newVal, oldVal) {
      this.isHomePage();
    },
    getEventsDetail(newVal, oldVal) {
      this.isHomePage();
    },
    isHomepageActive(newVal, oldValue) {
      if (newVal !== oldValue) {
        window.parent.postMessage(
          {
            type: 'statusHomepage',
            status: newVal
          },
          '*'
        );
      }
    },
    getLiveMode(newValue, oldValue) {
      this.sendModeMessageToSkinV2();
    }
  }
};
</script>

<style scoped></style>
